<template>
  <div>
    <b-card class="md-3" style="min-height: 410px">
      <!-- Titulo de la seccion-->
      <b-row>
        <b-col class="align-left">
          <p style="padding-left:40px;">Agregar nuevo usuario</p>
        </b-col>
      </b-row>

      <!-- Formulario de adicion de nodos -->
      <div id="formulario-usuarios" style="width: 100%">
        <circle-loader ref="circleLoader" />

        <div v-if="!submitted">
          <!-- INIT FORMULARIO DE ADICION -->
          <b-form @submit="saveUser">
            <div class="groupBox">
              <!-- Fila 1 -->
              <b-row>
                <b-col>
                  <br />
                  <small
                    >Nota: El identificador único del usuario es su email, por lo <br />
                    que no podrá ser cambiado a posteriori excepto por un administrador
                  </small>
                </b-col>
                <!--spacer -->
                <b-col class="col-sm-1 col-xs-3"> </b-col>
                <!--spacer -->
                <b-col>
                  <b-form-group
                    label-size="sm"
                    label="Identificación fiscal (NIF/CIF) *"
                    label-for="nif"
                  >
                    <b-form-input
                      id="nif"
                      name="nif"
                      size="sm"
                      placeholder="..."
                      v-model="user.nif"
                      required
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Fila 2 -->
              <b-row>
                <b-col>
                  <b-form-group
                    label-size="sm"
                    label="Nombre del usuario *"
                    label-for="name"
                  >
                    <b-form-input
                      id="name"
                      name="name"
                      size="sm"
                      placeholder="..."
                      v-model="user.name"
                      required
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <!--spacer -->
                <b-col class="col-sm-1 col-xs-3"> </b-col>
                <!--spacer -->
                <b-col>
                  <b-form-group
                    label-size="sm"
                    label="Dirección de la residencia habitual"
                    label-for="address"
                  >
                    <b-form-input
                      id="type"
                      name="address"
                      size="sm"
                      placeholder="..."
                      v-model="user.address"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Fila 3 -->
              <b-row>
                <b-col>
                  <b-form-group
                    label-size="sm"
                    label="Apellidos del usuario *"
                    label-for="surname"
                  >
                    <b-form-input
                      id="surname"
                      name="surname"
                      size="sm"
                      placeholder="..."
                      v-model="user.surname"
                      required
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <!--spacer -->
                <b-col class="col-sm-1 col-xs-3"> </b-col>
                <!--spacer -->
                <b-col>
                  <b-row>
                    <b-col>
                      <b-form-group
                        label-size="sm"
                        label="Ciudad"
                        label-for="city"
                      >
                        <b-form-input
                          id="city"
                          name="city"
                          size="sm"
                          placeholder="..."
                          v-model="user.city"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group
                        label-size="sm"
                        label="Provincia"
                        label-for="province"
                      >
                        <b-form-input
                          id="province"
                          name="province"
                          size="sm"
                          placeholder="..."
                          v-model="user.province"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group
                        label-size="sm"
                        label="Código Postal"
                        label-for="zip"
                      >
                        <b-form-input
                          type="number"
                          onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                          id="zip"
                          name="zip"
                          size="sm"
                          placeholder="..."
                          v-model="user.zip"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <!-- Fila 3.1 -->
              <b-row>
                <b-col>
                  <b-form-group
                    label-size="sm"
                    label="Email de contacto *"
                    label-for="email"
                  >
                    <b-form-input
                      id="email"
                      name="email"
                      size="sm"
                      placeholder="...@..."
                      v-model="user.email"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <!--spacer -->
                <b-col class="col-sm-1 col-xs-1"> </b-col>
                <!--spacer -->
                <b-col>
                  <b-form-group
                    label-size="sm"
                    label="Rol del usuario *"
                    label-for="role"
                  >
                    <b-form-select
                      id="role"
                      name="role"
                      size="sm"
                      v-model="selectedRole"
                      style="cursor: pointer"
                    >
                      <b-form-select-option value="null"
                        >No especificado</b-form-select-option
                      >
                      <b-form-select-option
                        v-for="role in roleList"
                        v-bind:key="role.alias"
                        v-bind:value="role"
                      >
                        {{ role.alias }}
                      </b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Fila 3.2 -->
              <b-row>
                <b-col>
                  <b-form-group
                    label-size="sm"
                    label="Telefono de contacto *"
                    label-for="phone"
                  >
                    <b-form-input
                      id="phone"
                      name="surname"
                      size="sm"
                      placeholder="..."
                      v-model="user.phone"
                      required
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <!--spacer -->
                <b-col class="col-sm-1 col-xs-1"> </b-col>
                <!--spacer -->
                <b-col>
                  <b-form-group
                    label-size="sm"
                    label="Estado de la cuenta *"
                    label-for="status"
                  >
                    <b-form-select
                      id="status"
                      name="status"
                      size="sm"
                      v-model="user.status"
                      style="cursor: pointer"
                    >
                      <b-form-select-option value="true"
                        >Cuenta activa</b-form-select-option
                      >
                      <b-form-select-option value="false"
                        >Cuenta inactiva</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Fila 4 -->
              <b-row>
                <b-col>
                  <b-form-group
                    label-size="sm"
                    label="Contraseña de acceso **"
                    label-for="password"
                  >
                    <b-form-input
                      type="password"
                      id="password"
                      name="password"
                      size="sm"
                      placeholder="..."
                      min="6"
                      v-model="user.password"
                      required
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <!--spacer -->
                <b-col class="col-sm-1 col-xs-1"> </b-col>
                <!--spacer -->
                <b-col>
                  <b-form-group
                    label-size="sm"
                    label="Repita la contraseña de acceso **"
                    label-for="passwordcheck"
                  >
                    <b-form-input
                      type="password"
                      id="passwordcheck"
                      size="sm"
                      placeholder="..."
                      min="6"
                      v-model="passwordcheck"
                      required
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Fila 6 -->
              <b-row>
                <b-col>
                  <small>* El campo debe ser rellenado</small><br />
                  <small
                    >** La contraseña debe tener mínimo 6 caracteres (espacio en
                    blanco no permitido)</small
                  >
                </b-col>
                <!--spacer -->
                <b-col class="col-sm-1 col-xs-1"> </b-col>
                <!--spacer -->
                <b-col>
                  <b-form-group label-for="adduser">
                    <b-button
                      block
                      type="submit"
                      name="adduser"
                      id="adduser"
                      variant="primary"
                      style="margin: 0px 10px 10px 0px"
                    >
                      <i class="fas fa-edit"></i>
                      <span
                        class="text-uppercase"
                        style="
                          font-size: 12px;
                          font-weight: bold;
                          margin-left: 5px;
                        "
                        >Dar de alta al usuario</span
                      >
                    </b-button>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-form>
          <!-- END FORMULARIO DE ADICION -->
        </div>
        <!-- END V if submitted-->
      </div>
    </b-card>
  </div>
</template>


<script>
import UserService from "@/services/UserService";
import CircleLoader from "@/components/common/CircleLoader";

export default {
  name: "add-user",
  components: {
    "circle-loader": CircleLoader,
  },
  data() {
    return {
      user: {
        role: null,
        name: "",
        surname: "",
        nif: "",
        address: "",
        zip: "",
        city: "",
        province: "",
        phone: 0,
        email: "",
        status: false,
        password: "",
      },
      passwordcheck: "",
      roleList: [],
      selectedRole: null,
      submitted: false,
    };
  },
  methods: {
    retrieveRoles() {
      UserService.getAllRoles()
        .then((response) => {
          this.roleList = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    saveUser(e) {
      e.preventDefault();
      var data;
      //var self = this; // assign context to self variable - extremely important

      this.$refs.circleLoader.reset();
      if (
        this.user.password === this.passwordcheck &&
        this.user.password.length > 0
      ) {
        data = {
          role: this.selectedRole ? this.selectedRole : null,
          name: this.user.name,
          surname: this.user.surname,
          nif: this.user.nif,
          address: this.user.address,
          zip: this.user.zip,
          city: this.user.city,
          province: this.user.province,
          phone: this.user.phone,
          email: this.user.email,
          status: this.user.status ? true : false,
          password: this.user.password,
        };

        UserService.create(data)
          .then((response) => {
            //Mensaje de confirmacion
            this.$notify({
              group: "notificateDiv",
              type: "success",
              title: response.data.message
                ? response.data.message
                : "Usuario agregado correctamente",
              text: response.data.message
                ? ""
                : "Se ha agregado 1 nuevo usuario a la lista",
              duration: 3000,
              speed: 1000,
            });
            //Completar imagen y descargar div
            //Ocultamos el formulario
            this.submitted = true;
            this.$refs.circleLoader.showLoading("Registrando usuario ...");

            //Mostramos durante 2 segundos que se está gaurdando
            setTimeout(() => {
              //Checkar cabeceras e vuelta para cargar la X o el tick
              if (!response.data.code || response.data.code == 3000 || response.status == 202) {
                this.$refs.circleLoader.showEndError(
                  response.data.message
                );
              } else {
                this.$refs.circleLoader.showEndSuccess(
                  response.data.message
                );
              }
              //Temporizador antes de mostrar de nuevo el formulario
              setTimeout(() => {
                this.submitted = false;
                this.$refs.circleLoader.reset();

                //Emit event to notify parent to notify the other component
                this.$emit("rowadded");
                //Remove form data
                this.resetValues();
              }, 1500);
            }, 2500);
          })
          .catch((e) => {
            console.log(e);
            //Mensaje de confirmacion
            this.$notify({
              group: "notificateDiv",
              type: "success",
              title: "Error al agregar el usuario",
              text: "No se ha podido agregar 1 nuevo usuario a la lista",
              duration: 3000,
              speed: 1000,
            });
          });
      } else {
        this.$notify({
          group: "notificateDiv",
          type: "error",
          title: "Error en la contraseña y confirmación",
          text: "Las contraseñas no son iguales o no cumplen las condiciones establecidas",
          duration: 3000,
          speed: 1000,
        });
      }
    },

    resetValues() {
      // Reset our form values
      this.user = {
        role: null,
        name: "",
        surname: "",
        nif: "",
        address: "",
        zip: "",
        city: "",
        province: "",
        phone: 0,
        email: "",
        status: false,
        password: "",
      };
      //Default password confirmation
      this.passwordcheck = "";

      this.$refs.circleLoader.reset();

      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
  mounted() {
    this.retrieveRoles();
  },
};
</script>


<style scoped>
.groupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 30px;
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 30px;
}
</style>
